import { render, staticRenderFns } from "./HubPromotionsBanner.vue?vue&type=template&id=92ced14a&scoped=true"
import script from "./HubPromotionsBanner.vue?vue&type=script&lang=js"
export * from "./HubPromotionsBanner.vue?vue&type=script&lang=js"
import style0 from "./HubPromotionsBanner.vue?vue&type=style&index=0&id=92ced14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ced14a",
  null
  
)

export default component.exports